import { CompanyContact } from '@/modules/company/entities/interfaces/CompanyContact';
import CompanyService from '@/modules/company/services/companiesService';
import { useCallback, useState } from 'react';

const useContact = () => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [contact, setContact] = useState<CompanyContact>();

  const loadContact = useCallback(async (companyId: string) => {
    if (!companyId) {
      return;
    }

    setLoading(true);

    try {
      const { data: contacts } = await new CompanyService().getContacts(companyId);

      const contact = contacts.find((contact) => contact.isMainContact);
      setContact(contact);
    } catch (e) {
      console.error(e);

      const toastEvent = new CustomEvent('toast', {
        detail: {
          icon: 'close-circle-outline',
          title: 'Oops',
          text: 'Ops! Devido a um erro, não conseguimos buscar as informações do contato da empresa.',
          type: 'danger',
          align: 'right',
          titleColor: 'danger',
          position: 'bottom',
          shadow: true,
          duration: 10,
        },
      });

      window.dispatchEvent(toastEvent);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    isLoading,
    loadContact,
    contact,
  };
};

export default useContact;
